// ©2024 Austin App House. All rights reserved.
import React, {useRef} from "react";
import MessageSticker from "./MessageSticker";

const MessageList = ({messages, userId, sendMessage, fetchConversation, scrollToBottom, needScrollToBottom}) => {
    const ref = useRef(null);
    needScrollToBottom&&scrollToBottom(ref)
    return(
        <div
            ref={ref}
            style={{
                overflowY: 'scroll',
                overflowX: 'hidden',
                padding: '10px',
                maxHeight: '250px'
            }}
        >
            {
                messages.map((message, ind)=> (
                    <MessageSticker fetchConversation={fetchConversation} userId={userId} key={`${message._id}_${ind}`} sendMessage={sendMessage} message={message} />
                ))
            }
        </div>
    )
}

export default MessageList;
